import type { Metadata } from "@/lib/head";
import { Link } from "@/lib/nav";

import { sectionCardClass } from "@buildpy/ui/section-card";
import { cn } from "@/lib/utils";
import { TOOL_LINKS } from "@buildpy/core/modules/tools/links";

export const metadata: Metadata = {
  title: "인테리어 시공사 무료 도구 — 계약서·견적서 양식, 공사 안내문",
  description:
    "로그인 없이 바로 쓰는 인테리어 시공사용 무료 도구. 공정위 실내건축·창호, 국토부 민간건설공사 표준계약서와 견적서 양식 인쇄, QR 공사 안내문 만들기, 오늘의집 광고비 계약 1건당 비용 계산.",
};

// 무료 도구 목록 — 카드 4개.
const ToolsPage = () => (
  <div className="flex flex-col gap-5">
    <div>
      <h1 className="text-xl font-bold">무료 도구</h1>
      <p className="mt-1 text-sm text-muted-foreground">로그인 없이 바로 쓰고, 인쇄할 수 있습니다.</p>
    </div>
    <ul className="grid grid-cols-1 gap-3 md:grid-cols-2">
      {TOOL_LINKS.map((tool) => (
        <li key={tool.href}>
          <Link className={cn(sectionCardClass({ padding: "md", interactive: true }), "block h-full")} href={tool.href}>
            <p className="font-semibold">{tool.title}</p>
            <p className="mt-1 text-sm text-muted-foreground">{tool.summary}</p>
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default ToolsPage;
